import { CustomExercise } from '@cf-shared/data-model/exercise';
import { isPouchNotFound } from '@cf-shared/data-model/pouch';

// Module-level holder for the local `global_exercises` PouchDB instance owned by
// CoachExerciseSyncService. Lives outside Angular DI to break the import cycle that
// would otherwise form between `coach-exercise-sync.service.ts` (which imports `UserDb`)
// and `exercise-db.service.ts` (which is imported by `UserDb`). The owner registers via
// `setStagingDbHandle` on start and clears via `setStagingDbHandle(null)` on stop.

let stagingDb: any | null = null;

export function setStagingDbHandle(db: any | null): void {
  stagingDb = db;
}

// Returns the staging copy of an exercise, or null if not yet replicated. Callers fall
// back to the cloud function when null is returned.
export async function getStagingExerciseAsync(exerciseId: string): Promise<CustomExercise | null> {
  if (!stagingDb) return null;
  try {
    return (await stagingDb.get(exerciseId)) as CustomExercise;
  } catch (err) {
    if (isPouchNotFound(err)) return null;
    throw err;
  }
}
